import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  style: {"display":"none"},
  id: "downloadiframe"
}, null, -1)

import { useRoute } from "vue-router";
import { useNotifierStore } from "./store/notifier";
import { useConfirmStore } from "./store/confirm";
import ConfirmPopup from "./components/base/popups/ConfirmPopup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const $notifier = useNotifierStore();
const notifierState = $notifier.state;

const $confirm = useConfirmStore();

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(route).meta.layout), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    _createVNode(_component_v_snackbar, {
      modelValue: _unref(notifierState).opened,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(notifierState).opened) = $event)),
      color: _unref(notifierState).color,
      timeout: _unref(notifierState).timeout
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(notifierState).message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"]),
    _createVNode(ConfirmPopup)
  ]))
}
}

})